<div *ngIf="breakpoints.small || breakpoints.extraSmall">
    <form id="formgetphonenumberId" [formGroup]="getPhoneNumberForm" class="form modal-optins"
        (submit)="onGetPhoneNumberSubmit()" novalidate>
        <section [style.min-height.px]="contentHeigt" style="background: #F4F4F4;
            display: flex;
            flex-direction: column;">

            <div class="flex flex-row letsget-started">
                <span>
                    Let's Get Started
                </span>
            </div>

            <div class="flex flex-col welcome-title">
                <div>
                    <div class="welcome-logo mx-auto">
                        <img [src]="sharedDataService.assetsCdn('images/support security.svg')" alt="Welcome Logo" loading="lazy">
                    </div>
                    <div class="greet-user">
                        <div class="user-q1">
                            Enter information to be pre-approved for financing
                        </div>
                        <div class="user-q2">
                            Checking your options won't affect your credit score.
                        </div>

                    </div>
                </div>
                <div class="flex flex-col welcome-input">
                    <div class="input-layout relative mt-5">
                        <input formControlName="mobile" type="tel" id="input-group-1" maxlength="12"
                            class="input-typography border border-gray-300 block w-full  p-3"
                            [class.invalid-fields]="getPhoneNumberForm.controls['mobile'].invalid && getPhoneNumberForm.controls['mobile'].touched"
                            (input)="onMobileInput($event)" (keypress)="numberOnly($event)" placeholder="Mobile #">

                        <div class="custom-floating-label"
                            [style.opacity]="getPhoneNumberForm.value.mobile != '' ? '1 !important' : 0">
                            Mobile #
                        </div>
                        <div class="input-hints  one-line-hint">
                            <div class="text">
                                Mobile #
                            </div>
                        </div>
                    </div>

                </div>

            </div>

                <div  [ngStyle]="{   
                    'margin': getMargin(),
                    'background': '#F4F4F4'
                 }" >

                <div class="verify-btn">
                    <button type="submit" class="text-white font-bold py-2 px-4 rounded">
                        Submit
                    </button>


                </div>
                <div class="loan-desc"><span>All loans issued by</span>&nbsp;<img
                        [src]="sharedDataService.assetsCdn('images/webbank-logo-caroussel.svg')" alt="" loading="lazy"></div>
            </div>
        </section>
    </form>
</div>


<div class="loader__wrapper" *ngIf="showLoader">
    <div [ngStyle]="{ 
      'position': 'absolute',
      'left': '50%',
      'top': '50%',
      'transform': 'translate(-50%, -50%)',
      'content': 'url(../../../../assets/images/loader-icw.gif)',
      'width': 'calc(4em)',
      'height': 'calc(4em)' 
     }"></div>
  </div>
  
  